import { useState } from 'react';
import styles from './SectionInformation.module.scss';
import ArrowIcon from './assets/arrow.svg';
import classnames from 'classnames';
import { useNavigate } from "react-router-dom";
import { useLanguage } from '../../../contexts/LanguageContext';

export default function SectionInformation() {
    const { t } = useLanguage();
    const [linkInput, setLinkInput] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [isNotification, setIsNotification] = useState({
        visible: false,
        error: false
    });
    const navigate = useNavigate();
    
    const validLink = () => {
        if (
            !(
                linkInput.includes('https://www.instagram.com') ||
                linkInput.startsWith('@')
            )
        ) {
            console.log("Invalid Instagram link or username");
            if (isNotification.visible) return;
            setIsNotification({ visible: true, error: true });
            setTimeout(function () {
                setIsNotification({
                    visible: false, error: true
                })
            }, 2000);
        } else {
            if (isNotification.visible) return;
            setIsNotification({ visible: true, error: false });
            setTimeout(function () {
                setIsNotification({
                    visible: false, error: false
                })
                
                if (window.Telegram && window.Telegram.WebApp) {
                    (window.Telegram.WebApp as any).close();
                }
            }, 1000);
            console.log("Valid input");
        }
    };
    
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            validLink();
        }
    };

    return (
        <section className={styles["page__information"]}>
            <div className="information__container">
                <div className={styles["information__content"]}>
                    <h1 
                        className={styles["information__title"]}
                        onClick={() => navigate('/')}
                    >
                        {t('home.title')}
                    </h1>
                    <h2 className={styles["information__description"]}>
                        {t('home.description')}
                    </h2>
                    <div className={styles["information__form-container"]}>
                        <div className={styles["information__input-wrap"]}>
                            <input 
                                type="text" 
                                className={styles["information__input"]} 
                                placeholder={t('home.input.placeholder')}
                                value={linkInput}
                                onChange={(e) => setLinkInput(e.target.value)} 
                                onFocus={() => setIsFocused(true)}
                                onBlur={() => setIsFocused(false)}
                                onKeyDown={handleKeyDown}
                            />
                            <p className={styles['information__input-text']}>{t('home.input.hint')}</p>
                        </div>
                        <button className={styles["information__btn"]} onClick={validLink}>
                            <img src={ArrowIcon} alt="Arrow Icon" />
                        </button>
                    </div>
                </div>
            </div>
            <div
                className={classnames(
                    styles['notification-access'],
                    {
                        [styles.show]: isNotification.visible,
                        [styles.red]: isNotification.error && isNotification.visible,
                        [styles.green]: !isNotification.error && isNotification.visible,
                        [styles.red]: isNotification.error,
                        [styles.green]: !isNotification.error
                    }
                )}
            >
                {isNotification.error ? t('home.notification.error') : t('home.notification.success')}
            </div>
        </section>
    )
}